

































import MyDamageDetailSideCard from "@/components/report/user/MyDamageDetailSideCard.vue";
import Notifications from "@/components/thg/Notifications.vue";
import TableWrapper from "@/components/utility/TableWrapper.vue";
import LayoutReportWithBanner from "@/layouts/LayoutReportWithBanner.vue";
import { IBreadcrumb } from "@/lib/interfaces/utility/breadcrumb-interface";
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { handleError } from "@/lib/utility/handleError";
import { MrfiktivVehicleViewModelGen } from "@/services/mrfiktiv/v1/data-contracts";
import { FleetManagerModule } from "@/store/modules/fleet/manager-fleet.store";
import { VehicleFleetModule } from "@/store/modules/fleet/vehicle-fleet.store";
import { UserModule } from "@/store/modules/me-user.store";
import { ReportModule } from "@/store/modules/report.store";
import { VehicleModule } from "@/store/modules/vehicle.store";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    LayoutReportWithBanner,
    Notifications,
    TableWrapper,
    MyDamageDetailSideCard
  },
  filters: {
    simpleDoubleDigitDate
  }
})
export default class FleetVehicleView extends Vue {
  loading = false;
  selectedId: string | null = null;

  get breadCrumbs(): IBreadcrumb[] {
    const breadCrumbs: IBreadcrumb[] = [];

    breadCrumbs.push({
      text: this.$t("nav.FleetTableView.description"),
      disabled: false,
      exact: true,
      to: {
        name: "FleetHomeView",
        params: {}
      }
    });

    breadCrumbs.push({
      text: this.$t("common.nouns.vehicle"),
      disabled: false,
      exact: false,
      to: {
        name: "FleetVehicleView",
        params: {}
      }
    });

    return breadCrumbs;
  }

  get partnerId() {
    return ReportModule.partner.id;
  }

  get fleetIds() {
    return UserModule.fleetPermission?.filter(p => p.partnerId === this.partnerId).map(p => p.fleetId);
  }

  get fleetId() {
    return FleetManagerModule.current?.id;
  }

  get items() {
    return VehicleFleetModule.all;
  }

  get i18n() {
    return this.$t("views.fleet.FleetVehicleListView");
  }

  get headers() {
    return [
      {
        text: this.$t("objects.vehicle.timestamp.created"),
        align: "left",
        width: 120,
        value: "timestamp.created"
      },
      {
        text: this.$t("objects.vehicle.state"),
        align: "left",
        width: 150,
        value: "state"
      },
      {
        text: this.$t("objects.vehicle.numberplate"),
        align: "left",
        value: "numberplate"
      },
      {
        text: this.$t("objects.vehicle.identificationnumber"),
        align: "left",
        value: "identificationnumber"
      },
      {
        text: this.$t("objects.vehicle.registration.manufacturerName"),
        align: "left",
        value: "registration.manufacturerName"
      },
      {
        text: this.$t("objects.vehicle.registration.manufacturerDescription"),
        align: "left",
        value: "registration.manufacturerDescription"
      },
      {
        text: this.$t("objects.vehicle.ownership"),
        align: "left",
        value: "ownership"
      },
      { text: "", value: "controls", align: "right", sortable: false }
    ];
  }

  getState(item: MrfiktivVehicleViewModelGen) {
    if (!item.state) {
      return { color: "grey lighten-4", label: "" };
    }

    return VehicleModule.stateMap.get(item.state);
  }

  async mounted() {
    await this.load();
  }

  async load() {
    if (!this.fleetId) {
      return;
    }

    this.loading = true;

    try {
      await VehicleFleetModule.getAll({ partnerId: this.partnerId, fleetId: this.fleetId });
    } catch (error) {
      handleError(error);
    } finally {
      this.loading = false;
    }
  }

  async openDetail(item: MrfiktivVehicleViewModelGen) {
    this.$log.debug(item);
    if (!this.fleetId) {
      return;
    }

    this.loading = true;

    try {
      const vehicle = await VehicleFleetModule.getOne({
        partnerId: this.partnerId,
        fleetId: this.fleetId,
        id: item.id
      });
      this.selectedId = vehicle.id;
    } catch (error) {
      handleError(error);
    } finally {
      this.loading = false;
    }
  }
}
